/**
 * Config strings — Website Build Brief v2 §6.
 *
 * "The founding price-lock sentence and the counter seed are config strings —
 *  build it so it's a one-word deploy."
 *
 * Everything Ali may want to change without a code review lives in this file
 * and nowhere else. Change the value, push, done.
 */

export const config = {
  /**
   * Brief §1: "the signal counter starts at zero."
   * Added to the stored count before display. Leave at 0 unless Ali says otherwise.
   */
  counterSeed: 0,

  /**
   * Brief §5 display rule: show the numeric count only once signals >= this.
   * Below it, the block reads "Applications open · 50 founding seats", no number.
   */
  counterThreshold: 100,

  /**
   * Brief §8: official capacity. A constant — "the 50 is a constant, official
   * capacity never changes." Do not make this dynamic.
   */
  foundingSeats: 50,

  /**
   * Brief §6: the founding price-lock perk line. PENDING Ali's final wording
   * before Day 3 — swap this one string, nothing else.
   */
  priceLockLine:
    "$199/month — locked. Launch price is $299 and rises from there.",

  /**
   * EXTERNAL-SITE DIVERGENCE (see SOURCE.md).
   *
   * Where applications are actually taken. Empty string keeps the original
   * behaviour — the form POSTs to this deployment's own /api/apply.
   *
   * Set to an absolute URL on any deployment that has no /api/apply behind it.
   * That is the case wherever this page is served by the Next.js app rather
   * than by Azure Static Web Apps: the managed Function does not exist there,
   * /api belongs to Next's own route namespace, and the form would post into
   * a 404. A front page whose form silently fails is worse than one that
   * plainly says where to apply, so when this is set the form is replaced at
   * runtime with a short note and a link to it.
   */
  externalApplyUrl: "https://mycgo.ai/#apply",

  /**
   * Brief §7: pixels install day one. Empty string = not injected, so the page
   * stays clean until the real IDs arrive. Fill in and deploy.
   */
  analytics: {
    ga4MeasurementId: "", // e.g. "G-XXXXXXXXXX"
    metaPixelId: "", // e.g. "1234567890"
    linkedInPartnerId: "", // e.g. "1234567"
  },
} as const;
